/**
 * Build a public API URL for the marketing site.
 * Site fetch paths always include the `/api` prefix (e.g. `/api/articles`).
 * VITE_API_BASE may be empty (Vite proxy), an API origin, or origin + `/api`.
 */
export function buildPublicApiUrl(apiBase: string | undefined, path: string): string {
  if (!apiBase) {
    return path;
  }

  if (path.startsWith('/api/') || path === '/api') {
    const origin = apiBase.replace(/\/api\/?$/, '');
    return `${origin}${path}`;
  }

  return `${apiBase}${path}`;
}

/**
 * Absolute MCP Streamable HTTP URL for Cursor install deeplinks.
 */
export function resolveMcpServerUrl(apiBase?: string): string {
  const base = apiBase?.trim();
  if (!base) {
    return 'http://localhost:3001/mcp';
  }
  return base.replace(/\/api\/?$/, '/mcp');
}
